import { ApplicationConfig, inject, PLATFORM_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { authInterceptor } from './auth/interceptors/auth.interceptor';

import { routes } from './app.routes';
import { SocketService } from './shared/services/socket.service';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, withInMemoryScrolling({
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    })),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    provideAppInitializer(() => {
      console.log('🔥 APP INITIALIZER RUNNING');

      const socketService = inject(SocketService);
      const platformId = inject(PLATFORM_ID);
      if (isPlatformBrowser(platformId)) {
        console.log('🔥 APP INITIALIZER RUNNING (Browser)');
        return socketService.connect();
      }
    
      console.log('⚙️ Skipping socket connection during SSR');
      return;
    }), provideClientHydration(withEventReplay())
  ]
};
